import { render } from "./CheckBox.vue?vue&type=template&id=65f7247b&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"

import "./CheckBox.vue?vue&type=style&index=0&id=65f7247b&scoped=true&lang=css"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f7247b"]])

export default __exports__